/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_UppercaseInputs */

const nl_validation_password_uppercase = /** @type {(inputs: Validation_Password_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord moet minimaal één hoofdletter bevatten`)
};

/**

* @param {Validation_Password_UppercaseInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_uppercase = /** @type {((inputs?: Validation_Password_UppercaseInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_UppercaseInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_uppercase(inputs)
});
export { validation_password_uppercase as "validation.password.uppercase" }